<template>
  <div class="final-confirmation">
    <h2 class="h3 mb-2"><b>Are you sure?</b></h2>
    <p class="text-muted mb-4">This is your last chance. Here's what happens next:</p>

    <div class="card">
      <div class="card-body">
        <div v-if="expiryOn" class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons final-confirmation__icon">event</span>
          <div>
            <p class="mb-0"><b>{{ expiryOn }}</b></p>
            <p class="text-muted mb-0">PRO+ access ends</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons final-confirmation__icon">file_download</span>
          <div>
            <p class="mb-0"><b>HiiKER PRO+ no longer available</b></p>
            <p class="text-muted mb-0">Maps and features gone</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons final-confirmation__icon">save</span>
          <div>
            <p class="mb-0"><b>Your stats are saved</b></p>
            <p class="text-muted mb-0">Hikes and data stay on your account</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3">
          <span class="material-icons final-confirmation__icon">favorite_border</span>
          <div>
            <p class="mb-0"><b>Reactivate anytime</b></p>
            <p class="text-muted mb-0">We'll be here when you need us</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ expiryOn: string | null }>();
</script>

<style scoped lang="scss">
.final-confirmation {
  &__icon {
    color: var(--text-muted, #b2b2b2);
  }
}
</style>
